/**
 * News article page
 * WARNING uses dummy data
 */
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Container from "./../components/core/Container";
import { useQuery } from "@tanstack/react-query";
import NewsSidebar from "./../components/news/NewsSidebar";
import ImageContainer from "./../components/core/ImageContainer";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import PageSidebarContainer from "../components/core/PageSidebarContainer";
import ContentContainer from "../components/core/ContentContainer";
import Loading from "../components/core/Loading";

// Only BUIHA should have access to this
const enableTables = true;

// const data = {
//   id: 1,
//   title: "Welcome to the new BUIHA website!",
//   epoch: 1727198081,
//   author: "Tech Team",
//   authorimg: "buiha",
//   img: "https://buiha.org.uk/assets/img/resource/dev-camp-22.png",
//   mdcontent: `
//
// After over a year of development we are proud to launch the new BUIHA website.
// We rebuilt the site fully to provide a better experience for our users, especially on mobile devices.
// Much of the content will be familiar to you, but we have made some changes to the layout and navigation to make everything easier to find.
// This article will cover some of the new features, planned updates and how you can contribute to the site.
//
// ## New Features
// - Achievements System for Player Profiles
// - Filterable Rosters and Schedules
// - New Game Centre
// - Improvements to all pages
// - Revamped News System
// - Improved Mobile Experience
// - Dark Mode (Uses device settings)
//
// #### Lists
//
// **Unordered List:**
// - Item 1
// - Item 2
// - Subitem 2.1
// - Subitem 2.2
//
// **Ordered List:**
// 1. First item
// 2. Second item
//  1. Subitem 2.1
//  2. Subitem 2.2
//
// #### Links and Images
//
// **Link to [Example Website](https://example.com)**
//
// **Image Example:**
// ![Example Image](https://via.placeholder.com/150)
//
// #### Blockquotes
//
// > "Markdown is a lightweight markup language with plain-text formatting syntax."
//
// #### Code Blocks
//
// \`\`\`javascript
// function greet(name) {
//   return \`Hello, \${name}!\`;
// }
//
// console.log(greet('World'));
// \`\`\`
//
// #### Tables
//
// | Column 1      | Column 2      |
// | ------------- | ------------- |
// | Cell 1, Row 1 | Cell 2, Row 1 |
// | Cell 1, Row 2 | Cell 1, Row 2 |
//
// #### Horizontal Rules
//
// ---`,
// };


const News = () => {
  const { newsId } = useParams();

  const [data2, setData] = useState(undefined);
  const [notFound, setNotFound] = useState(false); // State to track 404 status

  useEffect(() => {
    setData(undefined);
    setNotFound(false);

    fetch(`${process.env.REACT_APP_BUIHA_API_URL}/news/article/${newsId}`)
      .then((response) => {
        if (response.status === 404) {
          setNotFound(true); // Set notFound to true if 404 status
          return null; // Stop further processing
        }
        return response.json();
      })
      .then((json) => {
        if (json) {
          setData(json);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [newsId]);

  if (notFound) {
    return (
      <Container>
        <Helmet>
          <title>News Not Found | BUIHA News</title>
          <meta
            name="description"
            content="The news article you are looking for could not be found."
          />
          <link rel="canonical" href={`https://buiha.org/news/${newsId}`} />
        </Helmet>
        <div className="text-center py-10">
          <h1 className="text-3xl font-bold">404 - News Article Not Found</h1>
          <p className="mt-4">
            The article you're looking for may have been removed or never
            existed.
          </p>
        </div>
      </Container>
    );
  }

  return data2 ? (
    <Container>
      <Helmet>
        <title>{data2.title} | BUIHA News</title>
        <meta name="description" content={`News article: ${data2.title}`} />
        <link rel="canonical" href={`https://buiha.org/news/${newsId}`} />
        <link rel="icon" type="image/png" href="/favicon.png" />

      </Helmet>
      <PageSidebarContainer
        children={
          <>
            <ContentContainer
              children={
                <>
                  <h1 className="text-2xl xs:text-3xl font-semibold leading-tight">
                    {data2.title}
                  </h1>
                  <p className="text-xs md:text-sm text-gray-500 text-darken leading-tight">
                    Posted by {data2.author_name} on{" "}
                    {new Date(data2.date * 1000).toLocaleDateString()}
                  </p>
                  <div className="w-full max-sm:h-72 sm:max-lg:h-96 lg:h-[500px] object-cover mt-2 xs:mt-4 lg:max-xl:h-108">
                    <ImageContainer
                      src={
                        data2.img
                          ? `https://buiha.org.uk/assets/img/resource/${data2.img}`
                          : "/placeholder2.jpg"
                      }
                      alt={data2.title}
                    />
                  </div>
                  <ReactMarkdown
                    className="pt-4 prose"
                    children={
                      data2.text
                    }
                    remarkPlugins={[remarkGfm]}
                  />
                </>
              }
              extraClasses={"mt-[10px]"}
            />
            <NewsSidebar game_data={data2.game} />
          </>
        }
      />
    </Container>
  ) : (
    <Loading />
  );
};


export default News;
